import script from "./SupportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportModal.vue?vue&type=script&setup=true&lang=ts"

import "./SupportModal.vue?vue&type=style&index=0&id=4d03b22d&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d03b22d"]])

export default __exports__